import axios from 'axios'

const state = {
  options: {},
  page: 1,
  serverTotal: 1,
  data: [],
  url: '/hr/loan',
  postUrl: '/hr/document/loan',
  loading: false,
  loadingStore: false,
}
const getters = {
  data(state) {
    return state.data
  },
  loading(state) {
    return state.loading
  },
  loadingStore(state) {
    return state.loadingStore
  },
}
const mutations = {}
const actions = {
  async fetch({commit}, queryParams) {
    try {
      state.loading = true
      const filterTemp = {};
        Object.keys(queryParams).forEach((key) => {
          if (queryParams[key]) filterTemp[key] = queryParams[key];
        });
        let params = {...filterTemp}
      const response = await axios.get(`${state.url}`, {
        params,
      });
      state.data = response.data.data;
      state.serverTotal = response.data.meta.total
      state.page = response.data.meta.current_page;

    } catch (err) {
      console.log('err', err);
    } finally {
      state.loading = false
    }
  },
  async store({commit, state, dispatch}, data) {
    console.log(data) 
    try {
      state.loadingStore = true
      const res = await axios.post(`${state.postUrl}`, data);
      dispatch('fetch')
      return res;
    } catch (err) {
      console.log('err', err);
    } finally {
      state.loadingStore = false
    }
  },
  async update({commit, state, dispatch}, data) {
    try {
      state.loadingStore = true
      const res = await axios.put(`/hr/document/${data.id}/loan`, data);
      dispatch('fetch')
      return res;
    } catch (err) {
      console.log('err', err);
    } finally {
      state.loadingStore = false
    }
  },

}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
